export default "__VITE_ASSET__DIxIHecx__"